import { render, staticRenderFns } from "./form-recuperarSenha.vue?vue&type=template&id=31b7fd18"
import script from "./form-recuperarSenha.vue?vue&type=script&lang=js"
export * from "./form-recuperarSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports